import { render, staticRenderFns } from "./v-contextual.vue?vue&type=template&id=27197aaf&scoped=true"
import script from "./v-contextual.vue?vue&type=script&lang=js"
export * from "./v-contextual.vue?vue&type=script&lang=js"
import style0 from "./v-contextual.vue?vue&type=style&index=0&id=27197aaf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27197aaf",
  null
  
)

export default component.exports